import {
  AdaaHelper,
  isAikpi,
  isDkpi,
  isDtkpi,
  isImkpi,
  isIptkpi,
  isMokpi,
  isMtkpi,
  isNkpi,
  isNtkpi,
  isOpm,
} from "../../../../../core/utils";
import { Constants } from "../../../../constants/constants";

export const checkVisionTargetLabel = (itemType: number) => {
  if (isNkpi(itemType) || isNtkpi(itemType) || isOpm(itemType)) return "kpi.optimal_target";
  if (
    isDkpi(itemType) ||
    isDtkpi(itemType) ||
    isMokpi(itemType) ||
    isMtkpi(itemType) ||
    isIptkpi(itemType) ||
    isImkpi(itemType) ||
    isAikpi(itemType)
  )
    return "kpi.dkpi_target";
  else return "";
};

export const isKpiWorkflow = (itemTypeId: number) => {
  if (AdaaHelper.isObjectKPI(itemTypeId)) return true;

  switch (itemTypeId) {
    case Constants.CONSTANT_WORKFLOW.NKPI:
    case Constants.CONSTANT_WORKFLOW.SKPI:
    case Constants.CONSTANT_WORKFLOW.MOKPI:
    case Constants.CONSTANT_WORKFLOW.MTKPI:
    case Constants.CONSTANT_WORKFLOW.OKPI:
    case Constants.CONSTANT_WORKFLOW.DKPI:
    case Constants.CONSTANT_WORKFLOW.EKPI:
    case Constants.CONSTANT_WORKFLOW.SEKPI:
    case Constants.CONSTANT_WORKFLOW.IPTKPI:
    case Constants.CONSTANT_WORKFLOW.IMKPI:
    case Constants.CONSTANT_WORKFLOW.AIKPI:
      return true;
    default:
      return false;
  }
};

export const metricTypeOptions = [
  { value: Constants.METRICS_TYPE.GLOBAL, text: "main_types.G" },
  { value: Constants.METRICS_TYPE.LOCAL, text: "main_types.L" },
  { value: Constants.METRICS_TYPE.DIMENSION, text: "main_types.D" },
];

export const isTransformationalAgreement = (itemType: number | undefined): boolean => {
  switch (itemType) {
    case Constants.CONSTANT_TRANSFORMATIONAL_PROJECT_AGREEMENT:
    case Constants.CONSTANT_TRANSFORMATIONAL_PROJECT_AGREEMENT_DS3:
      return true;
    default:
      return false;
  }
};
